import { type IMediator } from '#/core/mediator';

import { SERVICES_TYPES } from '#/services-types';

import { type ILogService } from '../log';

import { type IStorageService, type PermanentStorageKey } from './storage.types';

export class StorageService implements IStorageService {
  readonly #serviceName = 'StorageService';

  get #logService() {
    return this._mediator.get<ILogService>(SERVICES_TYPES.LogService);
  }

  #storageKeyPrefix = 'cha-';

  constructor(private readonly _mediator: IMediator) {
    this.#logService.info(this.#serviceName, 'Instance was created.');
  }

  getFromPermanent(key: PermanentStorageKey) {
    return localStorage.getItem(`${this.#storageKeyPrefix}${key}`);
  }

  setToPermanent<D extends string | number | boolean | Record<string, unknown> | Array<unknown>>(
    key: PermanentStorageKey,
    data: D
  ) {
    const stringifyData = typeof data === 'object' ? JSON.stringify(data) : data.toString();

    localStorage.setItem(`${this.#storageKeyPrefix}${key}`, stringifyData);
  }
}
